import useApiQuery from 'shared/hooks/use-api-query';
import {PermissionGroupProps} from '../types';

const usePermissionGroupsForCitiesSelect = () => {
  const {data = [], ...query} = useApiQuery<PermissionGroupProps[]>({
    url: '/permission-groups/cities/all',
  });

  return {
    data: data
      ?.filter((group) => group.name !== 'Entregador')
      ?.map((group) => ({label: group.name, value: group.id})),
    ...query,
  };
};

export default usePermissionGroupsForCitiesSelect;
